<template>
  <div>
    <!-- Filter Start -->
    <!-- <div class="innerBox mb-4">
            <div class="row"> -->
    <!-- <a class="navbar-brand ml-3">Cek Status Truk</a> -->
    <!-- <div class="col-md-9">
                    <input
                        class="form-control filterInput"
                        type="search"
                        placeholder="Masukkan Kode Dealer"
                        aria-label="Search"
                    >
                </div>
                <div class="col-md-3 text-right">
                    <button
                        class="btn"
                        type="button"
                        style="background-color: #1B698E; color: white; padding: 0 50px; height: 100%; font-weight: bold;"
                    >CARI</button>
                </div>
            </div>
        </div> -->
    <panel class="border border-secondary" :noExpand="true">
      <template slot="header">
        <h4
          class="panel-title"
          style="font: normal normal normal 12px/18px Poppins"
        >
          Filter Options
        </h4>
      </template>
      <div class="row outerBox filterBox">
        <div
          class="col-md-2 mobileFilterPaddingTop align-items-center justify-content-center d-flex"
        >
          <label
            for="partshopCode"
            style="font: normal normal normal 16px/18px Poppins"
            >Search</label
          >
        </div>
        <div class="col-md-7">
          <input
            type="text"
            class="form-control"
            v-model="filter.search"
            placeholder="Type Username"
            style="font: normal normal normal 16px/25px Poppins"
          />
        </div>
        <div
          class="col-md-3 mobileFilterPaddingTop"
          style="display: flex; flex-direction: column-reverse"
        >
          <button
            type="button"
            class="btn btn-primary"
            style="
              height: 38px;
              margin-bottom: 0.5%;
              font: normal normal 600 14px/21px Poppins;
              text-transform: uppercase;
            "
            @click="vue_universal_table.update++"
          >
            Cari
          </button>
        </div>
      </div>
    </panel>
    <!-- Filter End -->

    <!-- Table Start -->
    <div class="innerBox">
      <div class="row">
        <div class="col-md-12">
          <h3
            class="tableTitle"
            style="font: normal normal normal 16px/25px Poppins"
          >
            User Management
          </h3>
        </div>
      </div>
      <vue-universal-table
        api_url="/api/user/userDashboardList"
        :filter="filter"
        :special_buttons="['newUser']"
        :buttons="vue_universal_table.buttons"
        :fields="vue_universal_table.fields"
        :update="vue_universal_table.update"
        :process_data="vue_universal_table.process_data"
        sort_order="DESC"
        sort_by="user_id"
        style="font: normal normal normal 12px/18px Poppins"
        @onNewUser="modal.new = true"
        @onEdit="editUser"
        @onDelete="deleteUser"
      ></vue-universal-table>
    </div>
    <!-- Table End -->

    <!-- Modal Start -->
    <user-management-detail
      v-if="modal.new || modal.edit"
      :data="modal.edit ? modal.editData : null"
      api_new="/api/user/userDashboardRegister"
      api_edit="/api/user/updateUserDashboard"
      form_type="User Dashboard"
      :is_company_exist="false"
      @refreshData="vue_universal_table.update++"
      @closeModal="
        modal.new = false;
        modal.edit = false;
      "
    ></user-management-detail>
    <!-- Modal End -->
  </div>
</template>

<script>
import userManagementDetail from "./children/UserManagementDetail";

export default {
  metaInfo: {
    title: "Dashboard User Management",
  },
  data() {
    return {
      modal: {
        new: false,
        edit: false,
        editData: false,
      },
      filter: {
        search: "",
      },
      vue_universal_table: {
        buttons: [
          {
            title: "Edit",
            variable: null,
            class: "fas fa-edit btn-outline-primary",
          },
          {
            title: "Delete",
            variable: "user_id",
            class: "fas fa-trash btn-outline-danger",
          },
        ],
        fields: [
          { title: "User Name", variable: "username" },
          { title: "Type", variable: "type" },
          {
            title: "Status",
            variable: "status",
            style_condition: {
              ACTIVE: "color:green; font-weight:bold",
              INACTIVE: "color:red; font-weight:bold",
            },
          },
        ],
        update: 0,
        process_data: `
                        for(var i in data) {
                            data[i].permission = data[i].permission
                        }
                    `,
      },
    };
  },
  components: {
    userManagementDetail,
  },
  mounted() {},
  methods: {
    editUser(user) {
      this.modal.editData = JSON.parse(user);
      this.modal.edit = true;
    },
    deleteUser(user_id) {
      this.$swal
        .fire({
          title: "Are you sure?",
          text: "You are about to end this (man/woman)'s whole career!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085D6",
          cancelButtonColor: "#D33",
          confirmButtonText: "Delete",
        })
        .then((result) => {
          if (result.value) {
            this.$http
              .delete("/api/user/deleteUserDashboard?id=" + user_id)
              .then(() => {
                this.$swal.fire({
                  title: "Success!",
                  icon: "success",
                  type: "success",
                  text: `User telah dinonaktifkan`,
                });
                this.vue_universal_table.update++;
              })
              .catch((error) => {
                this.$swal.fire({
                  title: "Error!",
                  icon: "error",
                  type: "error",
                  text: error.response.data.message,
                });
              });
          }
        });
    },
  },
};
</script>

<style scoped>
.innerBox {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 20px;
}

.chart {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 20px;
  align-items: center;
}

.elegant--sub-title {
  font-size: 18px;
  font-weight: 500;
  color: #9f9f9f;
}

.tableTitle {
  text-align: center;
}

/* .center {
        padding: 50px 20px;
        display: flexbox;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    } */

.stats--icon {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.table td,
.table th {
  text-align: center;
  font: normal normal normal 12px/18px Poppins;
}
</style>
